import React, { Component } from "react";
import Header from "../../components/shared/Header";
import Footer from "../../components/shared/Footer";
import { Link } from "react-router-dom";
import axios from "axios";
import * as ConstantVar from "../../constants_var";

class VerifyToken extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  async componentDidMount() {
    //verify token from DB
    let token = await this.props.token;

    axios
      .post(ConstantVar.API_BASE_URL + "/auth/recovery/verify", {
        token: token,
      })
      .then((response) => {
        //check response
        if (response.data.status === "true") {
          //save reset token to local storage
          localStorage.setItem("resetToken", token);
          document.getElementById("gotoComplete").click();
        }
      })
      .catch((err) => {
        document.getElementById("gotoFailed").click();
      });
  }
  render() {
    return (
      <>
        <Header />
        <div
          className="page-content"
          style={{
            height: "700px",
          }}
        >
          <div className="page">
            <div className="text-center" style={{ paddingBottom: 20 }}>
              <a>
                <img
                  className="loading-bar2"
                  src="data:image/png;base64,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"
                />
              </a>
            </div>
            <div className="text-center m-2">
              <h3>Verifying link</h3>
              <p>
                Please wait while we verify your link, this won't take long, keep your
                internet active.
              </p>
            </div>
          </div>
        </div>

        <Link id="gotoComplete" to="/account/recovery/update" type="hidden" hidden />
        <Link id="gotoFailed" to="/account/recovery/failed" type="hidden" hidden />

        <Footer />
      </>
    );
  }
}
export default VerifyToken;
